import React, { Component } from "react"
import ReactDOM from "react-dom/client"
import "./assets/icon/iconfont.css"
import "video.js/dist/video-js.css"
import "./index.less"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { get, post } from "@/untils/request"
import { history, HistoryRouter } from "@/router/history"

Component.prototype.get = get
Component.prototype.post = post

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <HistoryRouter history={history}>
    {/* <React.StrictMode> */}
    <App />
    {/* </React.StrictMode> */}
  </HistoryRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
